import adminReducer from "./adminReducer";
import companyReducer from "./companyReducer";
import defaultReducer from "./defaultReducer";
import messengerReducer from "./messengerReducer";
import profileReducer from "./profileReducer";
import windowDimensionsReducer from "./windowDimensionsReducer";

export default {
  defaultReducer,
  profileReducer,
  messengerReducer,
  companyReducer,
  windowDimensionsReducer,
  adminReducer,
};
